import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { RELATIVE_PAGE_PATHS } from '../../utils/constants';
import * as i18n from 'i18next';
import navigationMethods from '../../utils/navigationUtils';
import {
  hideHamburgerMenu,
  logout,
  showConfirmModal,
  closeModal,
} from '../../actions';
import { Col, Container } from 'reactstrap';
import MenuItem from './MenuItem';

class HamburgerMenu extends React.Component {
  renderMenuItems = () => {
    const { previousPage } = this.props;

    const menuItems = [
      {
        title: i18n.t('hamburgerMenu:myProfile'),
        action: () => {
          navigationMethods.navigate(RELATIVE_PAGE_PATHS.PROFILE);
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:subscriptionPlans'),
        action: () => {
          navigationMethods.navigate(RELATIVE_PAGE_PATHS.SUBSCRIPTION_PLANS);
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:myConsultants'),
        action: () => {
          navigationMethods.navigate(RELATIVE_PAGE_PATHS.SPECIALISTS);
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:myContacts'),
        action: () => {
          navigationMethods.navigate(RELATIVE_PAGE_PATHS.CONTACTS);
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:aboutTheApp'),
        action: () => {
          navigationMethods.openUrlInNewTab(
            i18n.t('hamburgerMenu:links.aboutTheApp')
          );
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:onlineStore'),
        action: () => {
          navigationMethods.openUrlInNewTab(
            i18n.t('hamburgerMenu:links.onlineStore')
          );
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:downloadJournal'),
        action: () => {
          navigationMethods.navigate(
            RELATIVE_PAGE_PATHS.REQUEST_JOURNAL_DOWNLOAD
          );
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:printJournal'),
        action: () => {
          navigationMethods.openUrlInNewTab(
            i18n.t('hamburgerMenu:links.printJournal')
          );
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:survey'),
        action: () => {
          navigationMethods.openUrlInNewTab(
            i18n.t('hamburgerMenu:links.survey')
          );
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:termsOfUse'),
        action: () => {
          navigationMethods.openUrlInNewTab(
            RELATIVE_PAGE_PATHS.TERMS_AND_CONDITIONS
          );
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:gdpr'),
        action: () => {
          navigationMethods.openUrlInNewTab(RELATIVE_PAGE_PATHS.GDPR);
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:contacts'),
        action: () => {
          navigationMethods.openUrlInNewTab(
            RELATIVE_PAGE_PATHS.CONTACTS_POLICIES
          );
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('homeScreenButton:addHomeScreenIcon'),
        action: () => {
          navigationMethods.navigate(RELATIVE_PAGE_PATHS.ADDHOMESCREEN);
          this.props.hideHamburgerMenu();
        },
      },
      {
        title: i18n.t('hamburgerMenu:exit'),
        action: () => {
          this.props.showConfirmModal({
            message: i18n.t('hamburgerMenu:confirmExit'),
            onConfirm: () => {
              this.props.closeModal();
              this.props.logout();
              this.props.hideHamburgerMenu();
            },
          });
        },
      },
    ];

    return menuItems.map((item, index) => {
      return (
        <MenuItem
          title={item.title}
          previousPage={previousPage}
          onClick={item.action}
          key={index}
        />
      );
    });
  };

  render() {
    if (this.props.showHamburgerMenu === 'DISABLED') {
      return <Fragment />;
    }

    const hamburgerContainerClass =
      this.props.showHamburgerMenu === 'HIDE'
        ? 'noPadding menu-disabled'
        : 'noPadding';
    const hamburgerMenuClass =
      this.props.showHamburgerMenu === 'HIDE'
        ? 'hamburger-menu hamburger-menu-disabled'
        : 'hamburger-menu';
    return (
      <Container className={hamburgerContainerClass}>
        <Col xs={12} sm={12} md={4} lg={4} className="centred noPadding">
          <div className={hamburgerMenuClass}>{this.renderMenuItems()}</div>
        </Col>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return { showHamburgerMenu: state.common.showHamburgerMenu };
};

export default connect(mapStateToProps, {
  hideHamburgerMenu,
  logout,
  showConfirmModal,
  closeModal,
})(HamburgerMenu);
